import { _js } from '@ifixit/utils/localize';
import { faRectangleCode } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const CodeBlockButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleCodeBlock().run()}
         isActive={editor.isActive('codeBlock')}
         isDisabled={!editor.can().toggleCodeBlock()}
         icon={<FontAwesomeIcon icon={faRectangleCode} />}
         /* Translators: "Code" as in monospaced font */
         title={_js('Insert code block')}
      />
   );
};
